export default __webpack_public_path__ + "static/code_realtime_theia_min-77e385c991c7276558de3a40dc4d1441.png";